import { motion } from "framer-motion";
import { Reveal, Overline } from "./Reveal";

const AUDIENCES = [
  "Service Businesses", "Professional Services", "Consultants", "Personal Brands",
  "Coaches & Educators", "Nonprofits", "Ministries & Mission-Driven", "Local Businesses", "Premium Service Providers",
];

export default function Who() {
  return (
    <section id="who" data-testid="who-section" className="border-t border-line px-6 py-28 md:px-12 md:py-40">
      <div className="mx-auto max-w-[1600px]">
        <Reveal><Overline>07 — Who We Work With</Overline></Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-8 max-w-3xl font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-white md:text-5xl">
            Built for businesses <span className="text-zinc-500">ready to grow</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-zinc-400 md:text-lg">
            TPA works best with organizations that want a serious growth partner — not just
            someone to make social posts.
          </p>
        </Reveal>

        <div className="mt-16 flex flex-wrap gap-3">
          {AUDIENCES.map((a, i) => (
            <motion.span
              key={a}
              data-testid={`audience-${a.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05, duration: 0.5 }}
              className="cursor-default border border-line px-5 py-3 font-display text-sm font-bold uppercase tracking-wide text-zinc-300 transition-colors duration-300 hover:border-white hover:text-white"
            >
              {a}
            </motion.span>
          ))}
        </div>
      </div>
    </section>
  );
}
